import React from "react";
import { m as motion, MAnimatePresence as AnimatePresence } from "./Motion";
import { modalVariants } from "shared/utils";

// Toast styling constants - can be reused across the app
export const TOAST_STYLES = {
  container: {
    width: "fit-content",
    padding: "0.6rem",
    borderRadius: "4px",
    fontSize: "0.75rem",
    fontWeight: "500",
    textAlign: "center",
    pointerEvents: "auto",
    backgroundColor: "var(--body-color)",
    background: "color-mix(in srgb, var(--title-color) 15%, var(--body-color))",
    color: "var(--title-color)",
    border: "1px solid color-mix(in srgb, var(--title-color) 12%, transparent)",
    marginRight: "4rem",
    zIndex: "1002",
  },
};

/**
 * Reusable Toast component for displaying temporary messages
 * @param {Object} props
 * @param {Object|null} props.message - Message object with type and text properties
 * @param {string} props.message.type - Type of message ('success' or 'error')
 * @param {string} props.message.text - Message text to display
 * @param {Object} [props.customStyles] - Optional custom styles to merge with defaults
 * @returns {JSX.Element}
 */
const Toast = ({ message, customStyles = {} }) => {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={modalVariants}
          transition={{ duration: 0.3 }}
          style={{ ...TOAST_STYLES.container, ...customStyles }}
        >
          {message.text}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;
